// Page View Events
export const PAGELOAD_HOME = 'LANDING_PAGE_HOME'
export const PAGELOAD_APPLY = 'LANDING_PAGE_APPLY'

// Header Events
export const CLICK_HEADER_LOGO_HOME = 'CLICK_HEADER_LOGO_HOME'
export const CLICK_HEADER_TAB_HOME = 'CLICK_HEADER_TAB_HOME'
export const CLICK_HEADER_TAB_WHY_TARGET_PLUS =
  'CLICK_HEADER_TAB_WHY_TARGET_PLUS'
export const CLICK_HEADER_TAB_HOW_IT_WORKS = 'CLICK_HEADER_TAB_HOW_IT_WORKS'
export const CLICK_HEADER_TAB_RESOURCES = 'CLICK_HEADER_TAB_RESOURCES'
export const CLICK_HEADER_SIGN_IN_BUTTON = 'CLICK_HEADER_SIGN_IN_BUTTON'
export const CLICK_HEADER_APPLY_NOW_BUTTON = 'CLICK_HEADER_APPLY_NOW_BUTTON'
export const CLICK_HEADER_MOBILE_MENU_TOGGLE = 'CLICK_HEADER_MOBILE_MENU_TOGGLE'
export const CLICK_HEADER_MOBILE_SIGN_IN = 'CLICK_HEADER_MOBILE_SIGN_IN'

// New Header Events
export const CLICK_HEADER_TAB_GET_STARTED = 'CLICK_HEADER_TAB_GET_STARTED'
export const CLICK_HEADER_TAB_GROW = 'CLICK_HEADER_TAB_GROW'
export const CLICK_HEADER_TAB_SERVICE_PROVIDERS =
  'CLICK_HEADER_TAB_SERVICE_PROVIDERS'
export const CLICK_HEADER_TAB_SUCCESS_STORIES =
  'CLICK_HEADER_TAB_SUCCESS_STORIES'
export const CLICK_HEADER_TAB_EVENTS = 'CLICK_HEADER_TAB_EVENTS'

// Hero Banner Events
export const CLICK_HEROBANNER_APPLY_NOW_BUTTON =
  'CLICK_HEROBANNER_APPLY_NOW_BUTTON'

// How It Works Events
export const CLICK_HOW_IT_WORKS_SEE_ELIGIBILITY_CHECKLIST =
  'CLICK_HOW_IT_WORKS_SEE_ELIGIBILITY_CHECKLIST'
export const CLICK_HOW_IT_WORKS_APPLY_NOW_BUTTON =
  'CLICK_HOW_IT_WORKS_APPLY_NOW_BUTTON'

// FAQ Events

export const CLICK_FAQ_ELIGIBILITY_CHECKLIST_LINK =
  'CLICK_FAQ_ELIGIBILITY_CHECKLIST_LINK'

// Footer Events
export const CLICK_FOOTER_APPLY_NOW_BECOME_PARTNER =
  'BUTTON_CLICK_FOOTER_APPLY_NOW_BECOME_PARTNER'

// Resources Events
export const CLICK_RESOURCES_ELIGIBILITY_CHECKLIST =
  'CLICK_RESOURCES_ELIGIBILITY_CHECKLIST'
export const CLICK_RESOURCES_ACCORDION_API_RESOURCES =
  'CLICK_RESOURCES_ACCORDION_API_RESOURCES'

// Partner Application Events
export const APPLICATION_FORM_STARTED = 'APPLICATION_FORM_STARTED'
export const APPLICATION_STEP_COMPLETED = 'APPLICATION_STEP_COMPLETED'
export const APPLICATION_SUBMITTED = 'APPLICATION_SUBMITTED'
export const APPLICATION_SUBMISSION_ERROR = 'APPLICATION_SUBMISSION_ERROR'
